{
  "email_unsubscribe": {
    "unsubscribe": "Se désabonner",
    "confirm_title": "Se désabonner",
    "confirm_content": "Êtes-vous sûr de vouloir vous désabonner ?",
    "its_official": "C'est officiel",
    "unsubscribed_thanks": "Vous vous êtes désabonné. Merci !",
    "all_communications": "toutes les communications"
  },
  "campaign_templates": {
    "campaign_templates": "Modèles de campagne",
    "new_template": "Nouveau modèle",
    "template_title": "Titre du modèle",
    "type_template_title": "Tapez le titre du modèle",
    "save_as_template": "enregistrer comme modèle",
    "rename_template": "Renommer le modèle",
    "please_enter_title": "Veuillez saisir un titre",
    "select_template_status": "sélectionner le statut du modèle",
    "status": {
      "active": "Actif",
      "archived": "Archivé"
    },
    "template": "Modèle",
    "first_name": "Prénom",
    "last_name": "Nom de famille",
    "job_title": "Titre du poste",
    "company_name": "Nom de l'entreprise",
    "primary_email": "Courriel principal",
    "id": "Id",
    "frequently_used": "Fréquemment utilisé",
    "open_in_browser": "Ouvrir dans le navigateur"
  },
  "template_actions": {
    "template_actions": "actions du modèle",
    "confirm_archive_title": "Êtes-vous sûr de vouloir archiver ce modèle ?",
    "confirm_archive_content": "Cliquez sur confirmer pour archiver",
    "confirm_clone_title": "Êtes-vous sûr de vouloir cloner ce modèle ?",
    "confirm_clone_content": "Cliquez sur confirmer pour cloner ce modèle.",
    "confirm_restore_content": "Veuillez confirmer pour restaurer le modèle.",
    "confirm_restore_title": "Restaurer le modèle ?"
  },
  "campaigns": {
    "status": {
      "all": "Tous",
      "draft": "Brouillon",
      "scheduled": "Programmé",
      "sending": "Envoi en cours",
      "sent": "Envoyé"
    },
    "filters": {
      "filter": "Filtrer",
      "clear_all": "Tout effacer",
      "created_by": "Créé par",
      "created_at": "Créé le",
      "scheduled_at": "Programmé le",
      "sent_at": "Envoyé le",
      "workspaces": "Espaces de travail",
      "workspaces_tooltip": "Filtrer par espaces de travail ou applications auxquels vous avez accès",
      "show_filters": "afficher les filtres",
      "filters_active": "{{count}} filtres sont actifs",
      "search_employees": "commencez à taper pour rechercher des employés",
      "search_workspace": "Rechercher un espace de travail",
      "type_email_search": "Tapez le courriel pour rechercher",
      "from": "De",
      "to": "À",
      "validation_date_range": "Veuillez sélectionner une date de début et une date de fin"
    },
    "actions": {
      "send_now": "Envoyer maintenant",
      "cancel_schedule": "Annuler la programmation",
      "save_as_template": "Enregistrer comme modèle",
      "clone": "Cloner",
      "ok": "Ok",
      "campaign_actions": "actions de campagne",
      "done": "Terminé",
      "preview": "Aperçu",
      "get_form_link": "Obtenir le lien du formulaire",
      "more": "Plus",
      "get_calendar_links": "Obtenir les liens du calendrier",
      "download_html": "Télécharger HTML",
      "show_less": "Afficher moins",
      "show_detail": "Afficher les détails"
    },
    "messages": {
      "send_now_header": "Envoyer la campagne maintenant ?",
      "send_now_caption": "Une fois envoyée, la campagne ne peut pas être annulée ou révoquée. Êtes-vous sûr de vouloir continuer ?",
      "cancel_schedule_title": "Annuler la campagne programmée ?",
      "cancel_schedule_content": "Nous déplacerons cette campagne vers l'onglet Brouillons.",
      "cancel_success": "Votre campagne programmée a été annulée avec succès.",
      "cancel_error": "L'annulation de la campagne a échoué. Actualisez et réessayez."
    },
    "headers": {
      "new_campaign": "Nouvelle campagne",
      "templates": "Modèles"
    },
    "tooltips": {
      "continuous_sending": "Envoi continu autorisé"
    },
    "table": {
      "columns": {
        "campaign_title": "Titre de la campagne",
        "workspace": "Espace de travail",
        "created_by": "Créé par",
        "created_at": "Créé le",
        "status": "Statut",
        "last_updated": "Dernière mise à jour",
        "scheduled_at": "Programmé le",
        "sent_time": "Heure d'envoi",
        "recipients": "Destinataires",
        "delivered": "Livré",
        "opened": "Ouvert",
        "clicked": "Cliqué",
        "failed": "Échoué",
        "unsub": "Désabonné"
      }
    }
  },
  "campaign": {
    "clone": {
      "confirm_title": "Êtes-vous sûr de vouloir cloner cette campagne ?",
      "confirm_content": "Cliquez sur confirmer pour cloner cette campagne."
    },
    "add_recipient": {
      "modal_title": "Ajouter un nouveau destinataire",
      "email_label": "Courriel",
      "email_placeholder": "Saisir le courriel",
      "send_scheduled": "Envoyer comme prévu",
      "send_now": "Envoyer maintenant",
      "placeholder": "Tapez le courriel du destinataire pour envoyer la campagne..."
    },
    "analytics": {
      "activities": "Activités",
      "clear_selection": "Effacer la sélection",
      "log_new_activity": "Enregistrer une nouvelle activité",
      "contact": "Contact",
      "company": "Entreprise",
      "location": "Localisation",
      "last_interaction": "Dernière interaction",
      "latest_status": "Dernier statut",
      "add_to_list": "Ajouter à la liste",
      "add_tags": "Ajouter des Tags",
      "log_new_activity_action": "Enregistrer une nouvelle activité",
      "summary": {
        "title": "Résumé",
        "title_for": "pour",
        "recipients": "Destinataires",
        "recipient": "Destinataire",
        "engagement": "Engagement",
        "delivery": "Livraison",
        "total_contacts": "Total des contacts",
        "out_of": "sur",
        "contacts_sent": "contacts envoyés",
        "contacts_delivered": "contacts livrés"
      },
      "status": {
        "delivered": "Livré",
        "clicked": "Cliqué",
        "opened": "Ouvert",
        "queued": "En file d'attente",
        "skipped": "Ignoré",
        "scheduled": "Programmé",
        "unscheduled": "Non programmé",
        "sent": "Envoyé",
        "unsubscribed": "Désabonné",
        "marked_as_spam": "Marqué comme spam",
        "failed": "Échoué",
        "opened_unique": "Ouvert (exclure l'interaction)"
      },
      "tooltips": {
        "latest_status": "Affiche le statut le plus récent du courriel envoyé à ce contact — tel que Livré, Ouvert, Cliqué, Désabonné ou Marqué comme Spam.",
        "skipped": "Ceci montre les contacts à qui la campagne n'a pas été envoyée. Les contacts peuvent être ignorés s'ils se sont précédemment désabonnés, ont rebondi, ou ont été signalés comme à haut risque lors du nettoyage de la liste.",
        "sent": "Le courriel a été mis en file d'attente avec succès et sera tenté pour la livraison. Il peut être livré si aucun problème ne survient, ou échouer selon la réponse du serveur de messagerie du destinataire.",
        "opened": "Le destinataire a ouvert le courriel. Cela inclut les destinataires qui ont par la suite interagi avec le courriel, comme les clics",
        "clicked": "Le destinataire a cliqué sur un lien à l'intérieur du courriel.",
        "unsubscribed": "Le destinataire s'est désabonné des futurs courriels après avoir reçu ce message.",
        "marked_as_spam": "Le destinataire a marqué le courriel comme spam après qu'il ait été livré.",
        "delivered": "Le courriel a été livré avec succès dans la boîte de réception des destinataires.",
        "failed": "Le courriel n'a pas pu être livré. Les raisons courantes incluent des adresses invalides, des boîtes de réception pleines, ou des problèmes de serveur."
      },
      "filters": {
        "select_statuses": "Sélectionner les statuts"
      },
      "list_cleaning": {
        "skip": "Ignorer",
        "verify_all": "Vérifier tout"
      },
      "table": {
        "columns": {
          "contact": "Contact",
          "company": "Entreprise",
          "location": "Localisation",
          "last_interaction": "Dernière interaction",
          "latest_status": "Dernier statut"
        }
      }
    },
    "filters": {
      "create_new_filter": "Créer un nouveau filtre",
      "define_custom_conditions": "Définissez des conditions personnalisées pour cette campagne.",
      "apply": "Appliquer",
      "filter": "Filtrer",
      "delivery_status": "Statut de livraison",
      "clicked_link": "Lien cliqué",
      "edit_filter": "Modifier le filtre",
      "add_filter": "Ajouter un filtre",
      "clear_all": "Tout effacer",
      "select_status": "Sélectionner le statut",
      "marked_as_spam": "Marqué comme spam",
      "filters_active": "filtres sont actifs",
      "show_filters": "afficher les filtres",
      "select_delivery_status": "sélectionner le statut de livraison",
      "preview_recipient_list": "Aperçu de la liste des destinataires"
    },
    "status": {
      "draft": "Brouillon",
      "scheduled": "Programmé",
      "sending": "Envoi en cours",
      "archived": "Archivé",
      "sent": "Envoyé",
      "unknown": "Inconnu"
    },
    "content": {
      "details": "Détails",
      "subject": "Objet",
      "from": "De",
      "recipients": "Destinataires",
      "attachment": "Pièce jointe",
      "content": "Contenu",
      "campaign_content": "Contenu de la campagne",
      "iframe_not_supported": "Votre navigateur ne prend pas en charge les iframes.",
      "add_new_recipient": "Ajouter un nouveau destinataire",
      "analytics": "Analyses"
    },
    "update": {
      "details": "Détails",
      "subject_placeholder": "Saisir l'objet de la campagne",
      "from": "De",
      "recipient_list": "Liste des destinataires",
      "filter_recipient_list": "Filtrer la liste des destinataires",
      "attachment": "Pièce jointe",
      "no_campaign_data": "Aucune donnée de campagne",
      "content": "Contenu",
      "select_template": "Sélectionner un modèle",
      "remove": "Supprimer",
      "campaign_email_template": "Modèle de courriel de campagne",
      "iframe_not_supported": "Votre navigateur ne prend pas en charge les iframes.",
      "select_sender": "Sélectionner l'expéditeur",
      "search_list": "Rechercher une liste"
    },
    "remove_content": {
      "confirm_title": "Êtes-vous sûr de vouloir supprimer ce contenu ?",
      "confirm_content": "Cliquez sur le bouton confirmer pour supprimer"
    },
    "settings": {
      "header": "Paramètres",
      "button": "PARAMÈTRES",
      "continuous_sending": "Autoriser l'envoi continu",
      "continuous_sending_caption": "Vous pouvez ajouter des participants supplémentaires après l'envoi de la campagne",
      "resend_existing": "Autoriser le renvoi aux destinataires existants",
      "resend_existing_caption": "Les destinataires peuvent recevoir cette campagne plus d'une fois.",
      "click_tracking": "Suivi des clics",
      "click_tracking_caption": "Surveille les liens dans un courriel et enregistre quand les destinataires cliquent dessus",
      "open_tracking": "Suivi d'ouverture",
      "open_tracking_caption": "Suit quand un courriel est ouvert par le destinataire"
    },
    "warning": {
      "all_set": "Tout est prêt! Cette liste est propre et prête à être envoyée.",
      "contact_issues_found": "Vérifier la liste de contacts avant l'envoi",
      "alert_checks_entire_list": "Nous avons identifié des problèmes dans votre liste de contacts. Veuillez examiner et nettoyer vos contacts avant l'envoi. Cette vérification passe en revue tous les contacts de votre liste{{filterText}}.",
      "filter_text_enabled": ", même ceux qui ne sont pas inclus dans le filtre appliqué",
      "high_risk_removed": "Les courriels à haut risque seront automatiquement supprimés des destinataires de la campagne.",
      "view_list": "Voir la liste",
      "clean_list": "Nettoyer la liste",
      "cleaning_in_progress": "Le nettoyage de la liste est en cours"
    },
    "attachment": {
      "cannot_delete": "Impossible de supprimer :",
      "cannot_upload": "Impossible de télécharger :"
    },
    "create": {
      "header": "Nouvelle campagne courriel",
      "name_label": "Nom",
      "name_placeholder": "Nom",
      "name_required": "veuillez saisir un nom",
      "create_button": "Créer une campagne"
    },
    "template": {
      "select": "Sélectionner {{title}}"
    },
    "actions": {
      "send_test": "Envoyer un test"
    },
    "archive": {
      "confirm_title": "Êtes-vous sûr de vouloir archiver cette campagne ?",
      "confirm_content": "Cliquez sur confirmer pour archiver cette campagne."
    },
    "select": {
      "placeholder": "Choisir une campagne"
    },
    "add_to_campaign": {
      "header": "Ajouter à la campagne",
      "select_campaign": "Sélectionner une campagne",
      "confirm_title": "Procéder à l'ajout à la campagne ?",
      "caption": "Vous pouvez ajouter des destinataires supplémentaires aux campagnes de courriels continues.",
      "contact": "contact",
      "contacts": "contacts",
      "confirm_content": "Êtes-vous sûr de vouloir ajouter {{count}} {{contactCountText}} à la \"{{campaignTitle}}\" ?",
      "warning": "Cela déclenchera immédiatement la campagne de courriel et ne peut pas être annulé"
    },
    "test_email": {
      "send_test": "Envoyer un test",
      "header": "Envoyer un courriel de test",
      "caption": "Tapez le courriel du destinataire pour envoyer la campagne. Une fois envoyé, il ne peut pas être rappelé ou modifié.",
      "email_label": "Courriel",
      "email_placeholder": "Entrez le courriel",
      "email_required": "Veuillez entrer un courriel valide"
    },
    "email_template": {
      "title": "Modèle de courriel de campagne",
      "iframe_not_supported": "Votre navigateur ne prend pas en charge les iframes.",
      "wrong_url": "on dirait que vous avez la mauvaise URL."
    },
    "schedule": {
      "send_now": "Envoyer maintenant",
      "time_zone": "Fuseau horaire",
      "select_timezone": "Sélectionner le fuseau horaire",
      "schedule_time": "Heure de programmation",
      "schedule": "Programmer",
      "clean_list_header": "Nettoyer la liste",
      "clean_list_caption": "Veuillez valider les adresses courriel pour garantir la précision avant d'envoyer des campagnes. Nous supprimerons automatiquement les courriels à haut risque si vous nettoyez la liste. Ignorer pour continuer sans nettoyer.",
      "send_campaign_now": "Envoyer la campagne maintenant ?",
      "schedule_campaign_header": "Programmer la campagne",
      "send_now_caption": "Une fois envoyée, la campagne ne peut pas être annulée ou révoquée. Êtes-vous sûr de vouloir continuer ?",
      "schedule_campaign_caption": "Vous êtes sur le point de programmer cette campagne pour qu'elle soit envoyée aux destinataires. Êtes-vous sûr ?"
    },
    "export": {
      "primary_view": "vue des destinataires de campagne",
      "secondary_view": "tous les destinataires de campagne"
    }
  },
  "exclusion": {
    "rules": {
      "page_description": "Ces règles déterminent quels contacts ou entreprises sont exclus du marketing. Les contacts peuvent être ajoutés aux listes marketing et seront signalés pour révision.",
      "tabs": {
        "companies": "Entreprises",
        "contacts": "Contacts"
      },
      "form": {
        "header": "Exclure",
        "edit_header": "Modifier",
        "caption": "Définir des règles pour signaler et exclure des contacts ou entreprises spécifiques dans la liste marketing",
        "exclusion_type_label": "Type d'exclusion",
        "applies_to_label": "S'applique à",
        "marketing_category_label": "Avec type de catégorie marketing",
        "company_name_label": "Nom de l'entreprise",
        "reason_label": "Raison",
        "reason_placeholder": "Saisir la raison",
        "select_field_label": "Sélectionner le champ",
        "select_field_placeholder": "Sélectionner un champ personnalisé",
        "value_label": "Valeur",
        "value_placeholder": "Sélectionner les options du champ",
        "company_placeholder": "Taper pour rechercher une entreprise"
      },
      "types": {
        "block": "Bloquer",
        "block_description": "Bloquer - Empêcher l'ajout de contacts aux listes et supprimer ceux existants",
        "warn_description": "Avertissement - Permettre l'ajout à la liste mais afficher un avertissement"
      },
      "table": {
        "headers": {
          "exclusion_type": "Type d'exclusion",
          "reason": "Raison",
          "fields": "Champs",
          "values": "Valeurs",
          "marketing_categories": "Catégories marketing",
          "created_date": "Date de création",
          "created_by": "Créé par",
          "company": "Entreprise",
          "added_date": "Date d'ajout",
          "added_by": "Ajouté par"
        }
      },
      "actions": {
        "edit": "Modifier",
        "delete": "Supprimer",
        "view_contacts": "Voir les contacts"
      },
      "confirmations": {
        "delete_contact_rule_title": "Êtes-vous sûr de vouloir supprimer cette règle ?",
        "delete_contact_rule_content": "Tous les contacts et entreprises liés à cette règle seront supprimés de la liste d'exclusion.",
        "delete_company_title": "Supprimer de cette liste ?",
        "delete_company_content": "En supprimant de cette liste, toutes les campagnes peuvent être envoyées à cette entreprise."
      },
      "validation": {
        "select_exclusion_type": "Veuillez sélectionner un type d'exclusion",
        "select_type": "Veuillez sélectionner un type",
        "enter_reason": "Veuillez saisir une raison",
        "choose_category": "Veuillez choisir au moins une catégorie",
        "select_company": "Veuillez sélectionner une entreprise",
        "select_custom_field": "Veuillez sélectionner un champ personnalisé",
        "select_option": "Veuillez sélectionner au moins une option",
        "select_value": "Veuillez sélectionner une valeur"
      }
    },
    "list": {
      "header": "Exclusion marketing",
      "description": "Ces entreprises ont été exclues du marketing. Vous pouvez toujours ajouter des contacts d'entreprises exclues aux listes marketing. Nous avertirons les utilisateurs concernant le marketing vers ces contacts. Veuillez contacter votre administrateur pour plus d'informations.",
      "all_categories": "Toutes",
      "category_placeholder": "Catégorie",
      "more_categories": "+{{count}} de plus",
      "add_company": {
        "button": "Exclure l'entreprise",
        "header": "Exclure l'entreprise",
        "company_name_label": "Nom de l'entreprise",
        "marketing_categories_label": "Catégories marketing"
      }
    },
    "types": {
      "select_placeholder": "Sélectionner le type d'exclusion"
    }
  }
}
